/**
 * 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 * 
 * QubePro ECharts / Canvas Temalandırma Motoru
 * - Grafiklerin tüm ekosistemde (PMS, ERP, BPM vb.) tutarlı olmasını sağlar.
 * - ECharts canvas için gerekli olan resolved (hex/rgb) renkleri merkezi olarak yönetir.
 * - Design Drift (token dışı renk) kontrolünden muaf standart yaklaşımdır.
 */

import { readCssVar } from './css-var.utils';

export interface ChartThemeColors {
  text: string;
  textSecondary: string;
  textTertiary: string;
  tooltipBg: string;
  tooltipBorder: string;
  grid: string;
  axis: string;
  accent: string;
  accentLight: string;
  pieBorder: string;
  onAccent: string;
  statusActive: string;
  severityInfo: string;
  severityWarning: string;
  severityDanger: string;
}

/**
 * Temaya göre (light/dark) grafik renklerini döndürür.
 * Değerler design-tokens.css ile tam uyumlu fallback'lere sahiptir.
 */
export function getChartThemeColors(isDark: boolean): ChartThemeColors {
  return {
    text: readCssVar('--text-primary', isDark ? '#ffffff' : '#201f1e'),
    textSecondary: readCssVar('--text-secondary', isDark ? '#c8c6c4' : '#605e5c'),
    textTertiary: readCssVar('--text-tertiary', '#8a8886'),
    
    tooltipBg: readCssVar(isDark ? '--bg-tertiary' : '--card-bg', isDark ? '#323130' : '#ffffff'),
    tooltipBorder: readCssVar(isDark ? '--border-hover' : '--border-color', isDark ? '#484644' : '#edebe9'),
    
    grid: readCssVar('--chart-grid', isDark ? '#323130' : '#f3f2f1'),
    axis: readCssVar('--chart-axis-mute', isDark ? '#6b7280' : '#a19f9d'),
    
    accent: readCssVar('--accent-primary', isDark ? '#60a5fa' : '#0078d4'),
    accentLight: readCssVar('--accent-light', isDark ? 'rgba(96, 165, 250, 0.15)' : '#deecf9'),
    
    pieBorder: readCssVar('--chart-pie-border', isDark ? '#1b1a19' : '#ffffff'),
    onAccent: readCssVar('--text-on-accent', '#ffffff'),
    
    statusActive: readCssVar('--status-active', isDark ? '#6ee7b7' : '#0f9d58'),
    severityInfo: readCssVar('--chart-severity-info', isDark ? '#60a5fa' : '#2563eb'),
    severityWarning: readCssVar('--chart-severity-warning', isDark ? '#fbbf24' : '#d97706'),
    severityDanger: readCssVar('--chart-severity-danger', isDark ? '#f87171' : '#dc2626'),
  };
}
